//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  GetItemDuration,
  GetItemName,
  GetItemSkinName,
  timeToCounter,
} from "@/tool";

export default {
  name: 'RollBox',
  props: {
    roiiListLoading: {
      type: Boolean,
      default: false
    },
    roiiHeroBg: {
      type: String,
      default: ''
    },
    roiiList: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
    };
  },
  filters: {
    GetItemDuration,
    GetItemName,
    GetItemSkinName,
    timeToCounter,
  },
  computed: {
    
  },
  methods: {

  }
};
